import { largeScreen } from "src/shared/constants/screenSizes";

import useClientState from "./useClientState";

export default (maxWidth = largeScreen) => {
  const currentWidth = useClientState("deviceSize", 0);

  return maxWidth > currentWidth;
};
